import { useEffect, useState } from 'react';
import styles from './BookingManagementBookingTable.module.css';
import commonStyles from "components/commonStyle/commonStyle.module.css";
import { FaCircleMinus } from "react-icons/fa6";
import { EmployBookingList } from 'modules/booking';
import EmployBookingListTable from '../bookingListTable/employBookingListTable';
import { getallBookingsList } from 'services/booking/get-all-bookings-list';
import EmployCancelPopup from '../bookinkPooup/employCancelPopup';
import { FaHistory } from 'react-icons/fa';

type SortConfig = {
    key: 'parentName' | 'age' | 'request_date' | 'date' | 'status' | null;
    direction: 'asc' | 'desc';
};


export default function BookingManagementBookingTable() {

    const [bookingsData, setBookingsData] = useState<EmployBookingList[]>([]);
    const [sortConfig, setSortConfig] = useState<SortConfig>({ key: null, direction: 'asc' });
    const [isCancelPopupOpen, setIsCancelPopupOpen] = useState(false);
    const [showFutureBooking, setShowFutureBooking] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState(false);
    const handleOpenCancelPopup = () => setIsCancelPopupOpen(true);
    const handleCloseCancelPopup = () => { setIsCancelPopupOpen(false); fetchData(); };
    const fetchData = async () => {
        setIsLoading(true);
        try {
            const rawBookingData = await getallBookingsList([
                'confirmed',
                'cancelledPending',
                'cancelledRejected',
                'cancelledConfirmed'
            ], showFutureBooking);

            if (rawBookingData.Kids_bookings_data) {
                const bookingData = rawBookingData.Kids_bookings_data
                    .map((booking: any) => {
                        const hasCancelledPending = ['cancelledPending'].includes(booking.recurrence_date_0_status) ||
                            ['cancelledPending'].includes(booking.recurrence_date_1_status) ||
                            ['cancelledPending'].includes(booking.recurrence_date_2_status) ||
                            ['cancelledPending'].includes(booking.recurrence_date_3_status);

                        let status = '';
                        if (booking.status === 'confirmed') {
                            status = hasCancelledPending ? 'teilweise offen' : 'teilweise storniert';
                        } else if (booking.status === 'cancelledPending') {
                            status = 'offen';
                        } else if (booking.status === 'cancelledConfirmed') {
                            status = 'bestätigt';
                        } else {
                            status = 'abgelehnt';
                        }

                        return {
                            ...booking,
                            kidName: `${booking.kid_first_name} ${booking.kid_last_name}`,
                            parentName: `${booking.profile_first_name} ${booking.profile_last_name}`,
                            status,
                            block: `${booking.start_time.substring(0, 5) || ''} - ${booking.end_time.substring(0, 5) || ''}`,
                            request_date: booking.request_date?.substring(0, 10) || ''
                        };
                    })
                    .filter((booking: any) => {
                        if (booking.recurrence === 'serial' && booking.status === 'teilweise storniert') {
                            return (
                                ['cancelledPending', 'cancelledConfirmed'].includes(booking.recurrence_date_0_status) ||
                                ['cancelledPending', 'cancelledConfirmed'].includes(booking.recurrence_date_1_status) ||
                                ['cancelledPending', 'cancelledConfirmed'].includes(booking.recurrence_date_2_status) ||
                                ['cancelledPending', 'cancelledConfirmed'].includes(booking.recurrence_date_3_status)
                            );
                        } else if (booking.recurrence === 'onetime' && booking.status === 'teilweise storniert') {
                            return false;
                        }
                        return true;
                    });

                bookingData.sort((a: any, b: any) => {
                    const isAOpen = a.status === 'offen' || a.status === 'teilweise offen';
                    const isBOpen = b.status === 'offen' || b.status === 'teilweise offen';

                    if (isAOpen && !isBOpen) return -1;
                    if (!isAOpen && isBOpen) return 1;

                    return new Date(b.date).getTime() - new Date(a.date).getTime();
                });
                setBookingsData(bookingData);
            }

        } catch (error) {
            console.error("Fehler beim Abrufen der daten:", error);
        } finally {
            setIsLoading(false);
        }
    };



    useEffect(() => {
        fetchData();
    }, [showFutureBooking]);


    const sortedBookings = [...bookingsData].sort((a, b) => {
        if (sortConfig.key) {
            let aValue = a[sortConfig.key];
            let bValue = b[sortConfig.key];
            if (aValue === undefined) return 1;
            if (bValue === undefined) return -1;

            if (
                (sortConfig.key === 'request_date' || sortConfig.key === 'date') &&
                typeof aValue === 'string' &&
                typeof bValue === 'string'
            ) {
                const aDate = new Date(aValue.split('.').reverse().join('-'));
                const bDate = new Date(bValue.split('.').reverse().join('-'));

                if (aDate < bDate) {
                    return sortConfig.direction === 'asc' ? -1 : 1;
                }
                if (aDate > bDate) {
                    return sortConfig.direction === 'asc' ? 1 : -1;
                }
            } else {
                if (aValue < bValue) {
                    return sortConfig.direction === 'asc' ? -1 : 1;
                }
                if (aValue > bValue) {
                    return sortConfig.direction === 'asc' ? 1 : -1;
                }
            }
        }
        return 0;
    });

    const handleSort = (key: 'parentName' | 'age' | 'request_date' | 'date' | 'status') => {
        let direction: 'asc' | 'desc' = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };


    return (
        <div className={styles.tableContainer}>
            <div className={styles.tableHeader}>
                <h2>Stornierungsanfragen</h2>

                <button className={`${commonStyles.commonButton} ${styles.cancelButton}`} onClick={handleOpenCancelPopup}>
                    <p>Stornierung</p>
                    <FaCircleMinus className={commonStyles.commonButtonIcon} />
                </button>
            </div>
            <EmployBookingListTable bookings={sortedBookings} onSort={handleSort} sortConfig={sortConfig} onback={fetchData} isCancel={true} />
            {showFutureBooking && 
                <button className={`${commonStyles.commonButton} ${styles.bookingButton} ${styles.showAllButton}`}
                    onClick={() => setShowFutureBooking(false)}
                >
                    {isLoading ? (
                        <div className={commonStyles.spinner}></div>
                    ) : (
                        "Vorherige Stornierungen anzeigen"
                    )}

                    <FaHistory className={commonStyles.commonButtonIcon} />
                </button>}
            <EmployCancelPopup isOpen={isCancelPopupOpen} onClose={handleCloseCancelPopup} />

        </div>
    );
}
